// CARTO basemaps now require an API key ("API KEY REQUIRED" watermark on tiles),
// so we use Esri's Dark Gray Canvas, which is keyless and matches the dark theme.
export const TILE_URL =
  'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Base/MapServer/tile/{z}/{y}/{x}';

export const TILE_ATTRIBUTION =
  '&copy; <a href="https://www.esri.com/">Esri</a>';

// Esri Dark Gray Canvas only publishes tiles up to z16.
export const TILE_MAX_ZOOM = 16;
